import * as React from 'react'
import CmsRouter from '../control/CmsRouter'

export default <CmsRouter initialLocation={window.location.href} />

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}
